import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import './index.css';
import App, { preloadRoute } from './App';
import { LanguageProvider } from './context/LanguageContext';

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </HelmetProvider>
  </React.StrictMode>
);

const rootElement = document.getElementById("root");

const renderApp = () => {
  if (rootElement.hasChildNodes()) {
    ReactDOM.hydrateRoot(rootElement, app);
  } else {
    ReactDOM.createRoot(rootElement).render(app);
  }
};

preloadRoute(window.location.pathname).then(renderApp).catch(renderApp);
